import axios from 'crypto-fetch/axios'
import cookie from '@ms/utils/cookie.js'
import customPush from 'custom-push'

let userId

export default {
  /**
   * 查看评论状态
   * @return {[Boolean]}                [firstComments]
   */
  async getCommentsStatus({ sportId, eventId }) {
    const data = await axios.get('/gossip/commentary/comment-status', {
      params: { sportId, eventId }
    })
    if (data) {
      this.updateCommentsNum(data.commentsNum)
      this.updateCommentsStatus(data.commentsStatus)
    }
  },
  /**
   * 获取用户权限 是否可发布评论
   * @return {[Boolean]}                [hasQuality]
   * @return {[Boolean]}                [hasBlocked]
   * @return {[Boolean]}                [firstComments]
   */
  async getUserCommentsAuthority() {
    const data = await axios.get('/gossip/comments/can-push-comments')
    this.setUserAuthority(data)
    return data
  },

  /**
   * 发表评论 需要用户登录
   * @param  {String} comments        [评论内容]
   * @param  {String} sportId        [sportId]
   * @param  {String} eventId        [比赛id]
   * @param  {String} eventStatus        [比赛状态]
   * @param  {String} nickName        [用户昵称，没有昵称，传手机号]
   * @return {[Number]}                [status 1正常评论（推送topic），2hide 被隐藏，只自己可见(不推送topic) 3block，没有产生评论（不显示评论）]
   */
  publishComments(body) {
    return axios.post('/gossip/comments/publish-comments', body, { self: true })
  },

  /**
   * 评论列表
   * @param  {String} eventId        [比赛id]
   * @param  {String} eventStatus        [比赛状态]
   * @param  {String} lastCommentsId        [上一条评论id]
   * @param  {String} limit        [查看条数，默认为50]
   * @return {[Object]}                [description]
   */
  async getComments(params) {
    const { eventId, eventStatus, lastCommentsId, limit = 50 } = params
    const data = await axios.get(`/gossip/comments/list?eventId=${eventId}&eventStatus=${eventStatus}&lastCommentsId=${lastCommentsId}&limit=${limit}`)
    if (lastCommentsId) {
      this.refreashComment(data)
    } else {
      this.setComment(data)
    }
  },

  /**
   * [subComments 评论信息推送]
   * @param  {[String]}  eventId      [当前比赛Id]
   * @param  {[String]}  topic        [订阅主题]
   * @param  {[Boolean]} isSub        [订阅/取消订阅]
   * @return {[type]}                 [description]
   */
  subComments({ isSub = true, eventId } = {}) {
    const topic = `live_commentary_comments_topic_${eventId}`
    const method = isSub ? 'sub' : 'unsub'
    customPush[method]({
      topic,
      pushType: 'GROUP',
      listener: isSub ? this.commentsCallback : null
    })
  },

  commentsCallback(data) {
    if (!userId) {
      userId = cookie.get('userId')
    }
    data = JSON.parse(data)
    // 作者更新不显示更新按钮 滑至最新位置
    // 他人更新在最新位置时显示新消息 不显示更新按钮
    // 他人更新已滑动位置时显示更新按钮 不滑动页面
    if (data && data.userId !== userId) {
      this.updateNewMessage(true)
    }
    this.updateCommentsList(data)
  }
}
